__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-01-16-1768558955-stable-dev/";